import { Adquirente } from "@/models";
import { Inject } from "inversify-props";
import { AdquirenteServiceAdapter } from "./adapter/AdquirenteServiceAdapter";

export class SaveAdquirenteUseCase {
	@Inject('AdquirenteServiceAdapter')
	private adquirenteServiceAdapter!: AdquirenteServiceAdapter

	create = async (adquirente: Adquirente) => await this.adquirenteServiceAdapter.create(adquirente)
	update = async (adquirente: Adquirente) => await this.adquirenteServiceAdapter.update(adquirente)
}